var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResources(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A) Icons / Tools / Resources") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "A)-Icons-/-Tools-/-Resources",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Resources",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5002288,2.25 L6.75022875,2.25 C5.09415986,2.2518945 3.75212325,3.59393111 3.75022875,5.25 L3.75022875,21 C3.75022875,21.4142052 4.08602355,21.75 4.50022875,21.75 L18.0002288,21.75 C18.4144423,21.75 18.7502288,21.4142136 18.7502288,21 C18.7502288,20.5857864 18.4144423,20.25 18.0002288,20.25 L5.25022875,20.25 C5.25117574,19.4219654 5.9221942,18.750947 6.75022875,18.75 L19.5002288,18.75 C19.9144339,18.7499798 20.2502288,18.4142052 20.2502288,18 L20.2502288,3 C20.2502288,2.5857948 19.9144339,2.25 19.5002288,2.25 L19.5002288,2.25 Z M17.2502288,11.2500938 L14.8494375,9.44998125 C14.7161028,9.35000625 14.532791,9.35000625 14.3994563,9.44998125 L12.0002288,11.2499063 L12.0002288,3.75 L17.2502288,3.75 L17.2502288,11.2500938 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResources);
export default __webpack_public_path__ + "static/media/resources.7eb5ef2d.svg";
export { ForwardRef as ReactComponent };